
  import React from "react"
  import Component from "/Users/antti/Code/owla-ja-kadonnut-walkia/src/layouts/index.js"
  import data from "/Users/antti/Code/owla-ja-kadonnut-walkia/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js